module.exports = __webpack_public_path__ + "img/wings.546bb3ac.png";